<template>
	<Layout>
		<Infos />
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';

export default {
	name:       'ViewEufInfos',
	components: {
		Layout,
		Infos: () => import('@js/components/EUF/Infos'),
	},
};
</script>

<style>

</style>
